import * as React from "react";

export interface ApiOnlineContextType {
  isOnline: boolean;
}

export const ApiOnlineContext = React.createContext<ApiOnlineContextType>({
  isOnline: true,
});
